import React from 'react';
import { useInView } from '../hooks/useInView';
import { Clock, FileWarning, Users } from 'lucide-react';
export function PainSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const problems = [{
    icon: <Clock className="w-8 h-8 md:w-10 md:h-10 text-cta" strokeWidth={1.5} data-id="element-71" />,
    title: 'Stress da Pianificazione',
    desc: 'Passi ore ogni sera a cercare sequenze sicure per la lezione del giorno dopo.'
  }, {
    icon: <FileWarning className="w-8 h-8 md:w-10 md:h-10 text-cta" strokeWidth={1.5} data-id="element-72" />,
    title: 'Mancanza di Protocolli',
    desc: 'Non hai guide specifiche per patologie, gravidanza o terza età.'
  }, {
    icon: <Users className="w-8 h-8 md:w-10 md:h-10 text-cta" strokeWidth={1.5} data-id="element-73" />,
    title: 'Clienti Difficili da Gestire',
    desc: 'Allievi con esigenze complesse che richiedono competenze specialistiche.'
  }];
  return <section className="bg-white py-12 md:py-20 px-4 border-t border-gray-100" data-id="element-74">
      <div className="max-w-5xl mx-auto" data-id="element-75">
        <div ref={ref} className={`fade-in ${isVisible ? 'is-visible' : ''}`} data-id="element-76">
          <h2 className="font-heading text-xl md:text-4xl text-headline font-extrabold text-center mb-10 md:mb-16 tracking-tight" data-id="element-77">
            Perché la maggior parte degli istruttori è esausta?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10" data-id="element-78">
            {problems.map((problem, idx) => <div key={idx} className="text-center" data-id="element-79">
                <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-cta/5 rounded-full mb-4 md:mb-6" data-id="element-80">
                  {problem.icon}
                </div>
                <h3 className="font-heading font-bold text-headline text-base md:text-lg mb-2" data-id="element-81">
                  {problem.title}
                </h3>
                <p className="text-body text-sm font-light leading-relaxed" data-id="element-82">
                  {problem.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}